import axios from "../utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addFranchise = createAsyncThunk(
  "location",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    try {
      const merchantId = selectedMerchant?._id || payload?.merchant;
      const url = merchantId ? `location?merchantId=${merchantId}` : "location";

      // If `locations` key exists and is a non-empty array, send only that
      const dataToSend = Array.isArray(payload.locations)
        ? {
          locations: payload.locations.map((loc) => ({
            ...loc,
            phone: String(loc?.phone || "").replace(/\D/g, ""),
          })),
        }
        : {
          merchant: payload?.merchant,
          name: payload.name,
          email: payload.email,
          phone: String(payload.phone || "").replace(/\D/g, ""),
          googlePlaceId: payload.googlePlaceId,
          tradingHours: payload.tradingHours,
        };

      const response = await axios.post(url, dataToSend);
      return response?.data;
    } catch (error) {
      const raw = error?.response?.data || error?.message;
      const message = typeof raw === "string" ? raw : raw?.message;
      const isDupPhone = typeof message === "string" && /E11000/i.test(message) && /phone/i.test(message);
      return thunkAPI.rejectWithValue({
        success: false,
        message: isDupPhone
          ? "A store with this phone number already exists. Please use a different phone or update the existing store."
          : (message || "Failed to create location"),
      });
    }
  }
);

export const getFranchises = createAsyncThunk(
  "allLocations",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    try {
      const query = new URLSearchParams();

      if (payload?.merchant) query.append("merchant", payload.merchant);
      if (payload?.page) query.append("page", payload.page);
      if (payload?.search) query.append("search", payload.search);
      if (payload?.duration) query.append("duration", payload.duration);

      if (payload?.limit) query.append("limit", payload.limit);
      else if (!payload?.duration) query.append("limit", 100);

      if (selectedMerchant?._id) query.append("merchantId", selectedMerchant._id);

      const url = `location/merchant?${query.toString()}`;
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const toggleFranchiseStatus = createAsyncThunk(
  "location/status",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.patch(`location/status/${payload?.id}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const editFranchise = createAsyncThunk(
  "location/update",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    try {
      const merchantId = selectedMerchant?._id || payload?.merchant;
      const url = merchantId
        ? `location/${payload?.id}?merchantId=${merchantId}`
        : `location/${payload?.id}`;
      const response = await axios.patch(url, payload);
      return response?.data;
    } catch (error) {
      const raw = error?.response?.data || error?.message;
      const message = typeof raw === "string" ? raw : raw?.message;
      const isDupPhone = typeof message === "string" && /E11000/i.test(message) && /phone/i.test(message);
      return thunkAPI.rejectWithValue({
        success: false,
        message: isDupPhone
          ? "A store with this phone number already exists. Please use a different phone or update the existing store."
          : (message || "Failed to update location"),
      });
    }
  }
);

export const deleteFranchise = createAsyncThunk(
  "location/delete",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    try {
      const merchantId = selectedMerchant?._id || payload?.merchant;
      const url = merchantId
        ? `location/${payload?.id}?merchantId=${merchantId}`
        : `location/${payload?.id}`;
      const response = await axios.delete(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getLocationById = createAsyncThunk(
  "location/id",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    const params = selectedMerchant ? { merchantId: selectedMerchant._id } : {};
    try {
      const response = await axios.get(`location/${payload?.id}`, { params });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);